var React = require('react');

function SlightlyRoundInline (props) {
    return React.createElement("svg",props,React.createElement("rect",{"width":"738","height":"500","rx":"64"}));
}

SlightlyRoundInline.defaultProps = {"width":"738","height":"500","viewBox":"0 0 738 500","fill":"none"};

module.exports = SlightlyRoundInline;

SlightlyRoundInline.default = SlightlyRoundInline;
